/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S6_OutroInputs */

const tr_servis_s6_outro = /** @type {(inputs: Servis_S6_OutroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kayıtlar geçerli saklama kurallarına tabidir; abonelik sonunda hemen silindikleri anlamına gelmez.`)
};

const en_servis_s6_outro = /** @type {(inputs: Servis_S6_OutroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Records are subject to the applicable retention rules; subscription expiry does not mean they are deleted immediately.`)
};

const de_servis_s6_outro = /** @type {(inputs: Servis_S6_OutroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für die Datensätze gelten die jeweiligen Aufbewahrungsregeln; das Abo-Ende bedeutet keine sofortige Löschung.`)
};

const ru_servis_s6_outro = /** @type {(inputs: Servis_S6_OutroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`К записям применяются соответствующие правила хранения; окончание подписки не означает их немедленного удаления.`)
};

/**
* | output |
* | --- |
* | "Records are subject to the applicable retention rules; subscription expiry does not mean they are deleted immediately." |
*
* @param {Servis_S6_OutroInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s6_outro = /** @type {((inputs?: Servis_S6_OutroInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S6_OutroInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s6_outro(inputs)
	if (locale === "de") return de_servis_s6_outro(inputs)
	if (locale === "ru") return ru_servis_s6_outro(inputs)
	return tr_servis_s6_outro(inputs)
});